import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { authInterceptor } from '@lib/interceptors/token.interceptor';
import { routes } from './app.routes';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { ThemeModule } from 'src/theme/theme.module';
import { neoConfig, fibConfig, nassConfig } from 'src/theme';
import { riyadConfig } from 'src/theme/configs/riyad.config';

export const appConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom([
            BrowserModule,
            NgbModule,
            BrowserAnimationsModule,
            // NEOIQ-2427: SidePanelService (providedIn: 'root') injects MatDialog. Root-scoped
            // services resolve their own dependencies from the true app-root injector, not from
            // whichever component's local `imports` happens to first request the service — so
            // MatDialogModule must be registered here, not just via AngularMaterialModule on
            // individual components. Without this, SidePanelService throws NullInjectorError as
            // soon as anything outside a component that locally imports AngularMaterialModule
            // (e.g. SideNavComponent, part of the eager LayoutComponent shell) injects it first.
            MatDialogModule,
            ThemeModule.forRoot({
                themes: [fibConfig, neoConfig, nassConfig, riyadConfig],
                active: 'fibConfig',
            }),
        ]),
        provideRouter(routes, withHashLocation()),
        provideHttpClient(withInterceptors([authInterceptor])),
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { subscriptSizing: 'dynamic' },
        },
    ],
};
